import React from 'react';
import styles from '../styles/elements/ErrorMessage.module.scss';

const ErrorMessage = (props) => {
    const {title, message} = props;
    return (
        <div className={styles.root}>
            <p className={styles.title}>{title}</p>
            <p className={styles.message}>{message}</p>
        </div>
    );
}

export default ErrorMessage;